export default __webpack_public_path__ + "static/media/Rancho.03b1d15f.png";